/**
 * ===========================
 * CheckAll UncheckAll Module 
 * ==========================
 */

const jfUncheckModule = (function () {
  'use strict';

  const config = {
    checkBoxes: $('input[type="checkbox"]'),
    uncheckBtn: $('input[data-uncheckall]'),
    checkAllBtn: $('input[data-checkall]'),
    globalCheckBtn: $('#edit-loc-tid').find('[data-checkall]')
  };

  //uncheck all items
  const uncheckAll = function(clicked) {
    const checkedBoxes = clicked.closest('form').find(config.checkBoxes);
    $.each(checkedBoxes, function (i) {
      const checkBox = checkedBoxes[i];
      if ($(checkBox).is(':checked')) {
        $(checkBox).prop('checked', false);
        $(checkedBoxes).prop('disabled', false);
      }
    });
  }

  //Check all items
  const checkAll = function(checked) {
    const AllCheckedInputs = checked.parent().find(config.checkBoxes);
    const AllCheckedInputsSiblings = checked.parent().children().find(config.checkBoxes);
    const checks = (AllCheckedInputs.length > 1) ? AllCheckedInputs : AllCheckedInputsSiblings; // Adjusted for mobile with condition
    
    $.each(checks, function (i) {
      const checkbox = checks[i];
      if(checked.is(':checked')){
        $(checkbox).not(checked).prop({
          'disabled': true,
          'checked': true
            }
          );
      } else {
        $(checkbox).prop(
          {
            'disabled': false,
            'checked': false
          }
        );
      }
    });
  }

  //Check Global
  const checkGlobal = function(checked) {
    if(checked.is(":checked")) {
      $(config.checkBoxes).prop('checked', true);
      $(config.checkBoxes).not(checked).prop('disabled', true);
    } else {
      $(config.checkBoxes).prop('checked', false);
      $(config.checkBoxes).prop('disabled', false);
    }    
  }

  // Event Handler
  const bindUIAction = function () {
    //Uncheck All
    config.uncheckBtn.on('click', function (e) {
      e.preventDefault();
      uncheckAll($(this));
      
    });

    //CheckAll
    config.checkAllBtn.on('change', function(e){
      checkAll($(this));
    });

    //globalCheck
    const globalBtn = config.globalCheckBtn.last();

    $(globalBtn).on('change', function(e){
      checkGlobal($(this));
    })

  };

  const init = function () {
    bindUIAction();
  };

  return {
    init: init
  }
  
}());